import { API_ROOT } from '../apiConfig';
import axios from 'axios';

export const isReadResult = (ownerId,data) => {
	return axios.post(`${API_ROOT}/api/UserNotifications/update?where=${ownerId}`,data)
		.then(response => response)
}